// Copyright (c) 2021, Comsearch, Inc., All rights reserved

const initialFormValues = Object.freeze({
  architecture: '%', // defaults to wildcard
  bandId: null,
  bandwidth: '',
  modelNumber: '',
  modulationType: '%', // defaults to wildcard
  radioCode: '',
  throughput: '',
  pagination: null,
})

export default initialFormValues
